import { lowerCase, isEmpty } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      currencySign: '€',
      termsChecked: false,
      newsletterRegister: false,
      localErrors: {}
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'cartEmpty',
      'getVatError',
      'getSelectedCurrency'
    ]),
    displayLocalErrors () {
      return !isEmpty(this.localErrors)
    }
  },
  methods: {
    validateForm () {
      this.localErrors = {}

      const requiredEls = this.$refs.checkoutForm.querySelectorAll('[required]')
      for (const requiredEl of requiredEls) {
        const field = lowerCase(requiredEl.dataset.field_name)
        if (requiredEl.getAttribute('name') === 'accept_terms') {
          if (!requiredEl.checked) {
            this.localErrors[requiredEl.getAttribute('name')] = this.t('form_validation_required', { params: [{ field }] })
          }
        }
        const isFieldInvalid = requiredEl.value.trim() !== ''
        if (isFieldInvalid) {
          continue
        }
        this.localErrors[requiredEl.getAttribute('name')] = this.t('form_validation_required', { params: [{ field }] })
      }

      if (this.albisOptions.rates === null || this.albisOptionsSelectedRate === null) {
        this.localErrors.albis_options = `<i class="fa fa-warning"></i> <strong>${this.t('albis.selected.rates.not.valid')}</strong>.`
      }

      this.$store.commit('setCheckoutLocalErrors', this.localErrors)
      if (!this.displayLocalErrors) {
        return true
      }

      this.openValidationErrorsModal()
      return false
    },
    openValidationErrorsModal () {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.$refs.CheckoutErrorsModal.openModal()
      })
    }
  }
}
